import React, { useState, useEffect } from 'react';
import { Radio, FormControlLabel, RadioGroup, Box, Typography, Button } from '@mui/material';
import { obtenerDatosHotel } from '../../services/motorService';
import webpay from './webpay1.png';
import Cookies from 'js-cookie';
import { useNavigate } from 'react-router-dom';

const Payment = () => {
    const [tarjetaEnGarantia, setTarjetaEnGarantia] = useState(null); // Guardar el valor de "tarjeta en garantía"
    const [loading, setLoading] = useState(true); // Manejar el estado de carga
    const hotCod = Cookies.get('hotCod');
    const [datosHotel, setDatosHotel] = useState({});
    const navigate = useNavigate(); // Hook para la navegación

    useEffect(() => {
        const getData = async () => {
            try {
                const data = await obtenerDatosHotel(hotCod); // Usa hotCod en la llamada a la API
                setDatosHotel(data);
                setTarjetaEnGarantia(data.MotorHotSolTarjeta); // Actualiza el estado con el valor de "tarjeta en garantía"
                setLoading(false); // Deshabilita el estado de carga
            } catch (error) {
                console.error('Error fetching hotel data:', error);
            }
        };
        getData();
    }, []);

    const handleConfirmarReserva = () => {
        // Acción de confirmar reserva
        // Implementa aquí la lógica que tienes en el resumen del checkout para confirmar la reserva
        console.log('Reserva confirmada');
        // Aquí podrías navegar a la página de confirmación
        navigate('/resumenReserva');
    };

    const handleAtras = () => {
        // Acción para ir a la pantalla anterior (Datos Personales)
        navigate('/datosPersonales');
    };

    if (loading) {
        return <p>Cargando...</p>;
    }

    return (
        <Box>
            {tarjetaEnGarantia === "S" ? (
                <Box>
                    <RadioGroup value="tarjeta" sx={{ mb: 2 }}>
                        <FormControlLabel
                            value="tarjeta"
                            control={<Radio />}
                            label={
                                <Box sx={{ display: 'flex', alignItems: 'center' }}>
                                    <img
                                        src={webpay}
                                        alt="Tarjeta de crédito"
                                        style={{ width: '200px', height: 'auto', marginRight: '10px' }}
                                    />
                                </Box>
                            }
                        />
                    </RadioGroup>
                </Box>
            ) : (
                <Box>
                    <Typography variant="body1" sx={{ mb: 2 }}>
                        <strong>El medio de pago es Transferencia Bancaria</strong>
                    </Typography>
                    <Typography variant="body1" sx={{ mt: 2 }}>
                        <strong>Datos para la transferencia:</strong>
                    </Typography>
                    <Typography variant="body2" sx={{ mt: 1 }}>
                        <strong>Banco:</strong> {datosHotel.Banco}
                    </Typography>
                    <Typography variant="body2">
                        <strong>Número de cuenta:</strong> {datosHotel.CuentaBanco}
                    </Typography>
                    <Typography variant="body2">
                        <strong>Alias:</strong> {datosHotel.aliascuenta}
                    </Typography>
                    <Typography variant="body2">
                        <strong>Contacto para enviar comprobante:</strong> {datosHotel.Contacto}
                    </Typography>
                    <Box sx={{ backgroundColor: '#f8d7da', padding: 2, borderRadius: 2, mt: 2, mb:2 }}>
                        <Typography variant="body2">
                            <strong>{datosHotel.Condiciones}</strong>
                        </Typography>
                    </Box>
                </Box>
            )}
        </Box>
    );
};

export default Payment;
